const ΚΛΕΙΔΙ = "YXBpX2tleT00NDJmZWNkYjgwMjcxOTJkNjVhZmVmOGU4MDI1MDRiMQ==";

export const getPoster = async (tmdbId) => {
    return getImageImpl(tmdbId, (json) => {
        const posters = json.posters;
        if (posters.length > 0) {
            return `https://image.tmdb.org/t/p/w342/${posters[0].file_path}`;
        } else {
            return null;
        }
    });
};

export const getBackdrop = async (tmdbId) => {
    return getImageImpl(tmdbId, (json) => {
        const backdrops = json.backdrops;
        if (backdrops.length > 0) {
            return `https://image.tmdb.org/t/p/w780/${backdrops[0].file_path}`;
        } else {
            return null;
        }
    });
};

const getImageImpl = async (tmdbId, mapper) => {
    let response;
    do {
        response = await fetch(
            `https://api.themoviedb.org/3/movie/${tmdbId}/images?${atob(
                ΚΛΕΙΔΙ
            )}`
        );

        if (response.status === 429) {
            const retryAfterMillis =
                Number(response.headers.get("retry-after")) * 1000;
            console.log(`Waiting ${retryAfterMillis} before loading poster`);
            await timeout(retryAfterMillis);
        } else {
            break;
        }
    } while (true);

    if (response.status === 404) {
        return null;
    }

    const json = await response.json();
    return mapper(json);
};

const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const getNowPlayingMovies = async () => {
    const response = await fetch(
        `https://api.themoviedb.org/3/movie/now_playing?${atob(ΚΛΕΙΔΙ)}`
    );

    return (await response.json()).results;
};
